<template>
  <a-spin :spinning="loading">
    <div class="card">
      <div class="card-header">
        <router-link to="/participants/new">
          <a-button type="primary" style="margin-bottom: 10px;"
            ><i
              class="fe fe-plus-circle font-size-15"
              title="Add participant"
              style="margin-right: 10px;"
            />
            New participant
          </a-button>
        </router-link>
      </div>

      <div class="card-body">
        <div style="text-align: center;">
          <a-table
            :columns="columns"
            :data-source="dataSource"
            :pagination="{ pageSize: 50 }"
            :row-key="(record) => record.id"
          >
            <span slot="lastLogin" slot-scope="text">
              <a-tag :color="text === null ? 'volcano' : 'green'">
                {{ text === null ? 'Logged out' : 'Logged in' }} </a-tag
              ><br />
              {{ text === null ? '' : 'Logged in since:' + text }}
            </span>

            <span slot="actions" slot-scope="record">
              <a-popconfirm
                title="Are you sure you want to delete this participant?"
                ok-text="Yes"
                cancel-text="No"
                @confirm="deleteParticipant(record.id)"
                ><a
                  ><i
                    class="fe fe-x-square align-middle text-danger"
                    title="Delete participant" /></a
              ></a-popconfirm>
              <router-link :to="`/participants/edit/${record.id}`">
                <a
                  ><i
                    class="fe fe-edit align-middle text-gray-6"
                    title="Edit participant"
                    style="margin-left: 10px;"
                /></a>
              </router-link>

              <!-- <a-popconfirm
            style="margin-left: 10px"
            title="Are you sure you want to ed this user?"
            ok-text="Yes"
            cancel-text="No"
            @confirm="deleteUser(record.id)"
            ><a
              ><i
                class="fe fe-user-x align-middle text-gray-6"
                title="Delete user" /></a
          ></a-popconfirm> -->
            </span>
          </a-table>
        </div>
      </div>
    </div>
  </a-spin>
</template>

<script>
import { ParticipantService } from '@/services/api'

const columns = [
  // {
  //   dataIndex: 'id',
  //   key: 'id',
  //   title: '#',
  //   scopedSlots: { customRender: 'id' },
  // },
  {
    title: 'Name (Short name)',
    dataIndex: 'nameShortName',
    key: 'nameShortName',
  },
  {
    title: 'VAT Code',
    dataIndex: 'vatCode',
    key: 'vatCode',
  },
  {
    title: 'Users',
    dataIndex: 'userNames',
    key: 'userNames',
  },

  {
    title: 'Collateral',
    dataIndex: 'collateral',
    key: 'collateral',
    align: 'center',
  },
  {
    title: 'Actions',
    scopedSlots: { customRender: 'actions' },
    align: 'center',
  },
]

export default {
  components: {},
  data() {
    return {
      columns: columns,
      dataSource: [],
      loading: false,
    }
  },
  methods: {
    deleteParticipant(participantId) {
      ParticipantService.delete(participantId).then((response) => {
        this.fetchParticipants()
      })
    },
    fetchParticipants() {
      ParticipantService.get().then((response) => {
        this.dataSource = response.data.data
      })
    },
  },
  mounted() {
    this.fetchParticipants()
  },
}
</script>
